export class Stats{
    // --- Totaux Divalto ---
  totalClientsDivalto?: number;
  totalClientsAtsDivalto?: number;
  totalClientsEdrDivalto?: number;
  totalClientsMdrDivalto?: number;

  totalPostesDivalto?: number;
  totalServeursDivalto?: number;
  totalEquipementsDivalto?: number;
  totalATSDivalto?: number;
  totalEDRDivalto?: number;
  totalMDRDivalto?: number;

  // --- Totaux RG ---
  totalPostesRG?: number;
  totalServeursRG?: number;
  totalEquipementsRG?: number;

  // --- Totaux BIT ---
  totalPostesBIT?: number;
  totalServeursBIT?: number;
  totalATSBIT?: number;
  totalEDRBIT?: number;
  totalMDRBIT?: number;

  // --- Écarts ---
  ecartRGPostes?: number;
  ecartBITPostes?: number;
  ecartRGServeurs?: number;
  ecartBITServeurs?: number;
  ecartRGEquipements?: number;
  ecartATS?: number;
  ecartEDR?: number;
  ecartMDR?: number;

  // --- Pourcentages ---
  pourcentageClientsATS: number = 0;
  pourcentageClientsEDR: number = 0;
  pourcentageClientsMDR: number = 0;
}